
const TeamSection = () => {
  const teamMembers = [
    {
      name: 'ローレンス・P・ロジャー',
      position: '最高経営責任者（CEO）',
      bio: 'Lawrence P. Roger氏は1998年以来、金融分野に深く関与しており、Lawrence P. Roger氏は国際プライベートエクイティ投資部門の責任者、アジア太平洋地域のプライベートエクイティ投資部門責任者、アメリカのプライベートエクイティ投資部門の上級パートナーなど、複数のリーダーシップ職を務めています。この期間中、彼は多くの投資プロジェクトを指導し、多くのプライベートおよび上場企業の取締役会での職務を果たしました。Lawrence P. Roger氏は、ケンブリッジ大学で国際関係の修士号を取得し、イェール大学経済学院で博士号を取得しています。彼は非営利分野で活動し、主に教育と政策に焦点を当てています。また、彼はいくつかの基金およびプライベートエクイティ会社の企業名誉顧問および取締役会メンバーでもあります。持続可能性に向けて導き、先を照らすだけではなく前進を指し示す道を築くことで、未来が持続可能な環境と社会福祉に根ざすようにします。環境にやさしく、社会的に安定した未来を創造する為に、導く役割と啓発の役割を果たします。',
      image: 'https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/fcf5c172520897a6fe5cf24c1cbfdda6.png',
      specialties: ['投資戦略', 'リスク管理', '企業分析'],
      linkedin: '#',
      email: 'lawrence@touaregglobal.co'
    },
    {
      name: 'イーサン・オースティン',
      position: '副社長',
      bio: 'Touareg Globalの副社長Ethan Austin氏は、地域市場のダイナミクスとグローバル戦略を監督する重大な役割を担っています。起業家として、彼は資本主義が肯定的な変化を導くことができるという信念に基づいて、エンジンNo.1を設立し、株主と投資家の利害関係を一致させる企業に導きました。トゥレイン大学で経済学の学士号を取得し、投資委員会の議長を務めたEthan Austin氏は、10年以上の経験を持ち、様々な産業分野にわたる投資およびビジネス開発分野で優れた能力を発揮しています。彼の印象的なキャリアは、共同管理パートナーおよびポートフォリオマネージャーとして活動し、キャピタル マネージメントを共同設立し、経営委員会の重要なメンバーとして働きました。',
      image: 'https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/b1defc335ec26466ce9809f381917452.png',
      specialties: ['グローバル戦略', '投資開発', 'ビジネス開発'],
      linkedin: '#',
      email: 'ethan@touaregglobal.co'
    },
    {
      name: 'クリス・マーティン',
      position: '金融・戦略投資家グループ（FSIG）の責任者',
      bio: 'トゥアレグ・グローバルの FSIG の責任者であり、世界中の政府系ファンド、保険会社、大手機関投資家とのパートナーシップを構築しています。グローバル経営委員会のメンバーとして、彼は会社の戦略的ビジョンを形成し、世界的な投資管理におけるリーダーシップを維持する上で重要な役割を果たしています。クリスのリーダーシップの下、FSIG は、複雑な投資戦略、ポートフォリオの最適化、変化する市場の需要への適応などの課題に対処しながら、機関投資家をサポートするトゥアレグ・グローバルのアプローチを変革しました。彼はまた、資本市場、バランスシート最適化、リスク管理、資本市場、高度な分析を専門とする金融市場アドバイザリー (FMA) 部門も監督しています。FSIG を率いるだけでなく、クリスは南北アメリカと中国本土での会社の拡大を推進し、これらの重要な市場での成長と存在感を高めています。彼はまた、同社のプライベートエクイティ子会社の取締役を務め、新興経済における長期投資戦略を推進している。',
      image: 'https://static.readdy.ai/image/41be8099d52dd4fa30a2ec6c94e7a004/217fc91cad851e5c4f94e75371930e5f.png',
      specialties: ['企業分析', '株式評価', 'マーケット調査'],
      linkedin: '#',
      email: 'yamada@touaregcapital.co'
    }
  ];

  return (
    <section id="team" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            経験豊富な<span className="text-blue-600">プロフェッショナル</span>チーム
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            多様な専門性を持つメンバーが、お客様の成功のために
            一丸となって取り組んでいます
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="relative overflow-hidden">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              
              <div className="p-6">
                <h4 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h4>
                <p className="text-blue-600 font-medium mb-3">{member.position}</p>
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">{member.bio}</p>
                
                <div className="mb-4">
                  <h5 className="text-sm font-semibold text-gray-900 mb-2">専門分野:</h5>
                  <div className="flex flex-wrap gap-2">
                    {member.specialties.map((specialty, specialtyIndex) => (
                      <span 
                        key={specialtyIndex}
                        className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full text-xs font-medium"
                      >
                        {specialty}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
